export const blogs = [
  {
    title: '10 Breathing Exercises that can help ease Anxiety',
    image:
      'https://t3.ftcdn.net/jpg/06/43/07/12/360_F_643071289_I60pgWvCavlK0pswqkibpeYudr0HY9Ft.jpg',

    professorPics: [
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSExIJT3xI3BmkKXtxbDD6z0SdKoh5LOAARdQ&s'
    ],
    duration: '5 min',
    description:
      " If you are a yoga enthusiast, you might practice breathing during your yoga sessions. You may have heard the phrase 'practice breathe exercises' in the event that you had to see your therapist or your doctor. If you're under stress, you could have done it...",
    id: 1
  },
  {
    title: '10 Breathing Exercises that can help ease Anxiety',
    image:
      'https://t3.ftcdn.net/jpg/06/43/07/12/360_F_643071289_I60pgWvCavlK0pswqkibpeYudr0HY9Ft.jpg',

    professorPics: [
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSlGy_p1OxCKPPo44Yry-6sXjEfIXkbblUzCQ&s'
    ],
    duration: '5 min',
    description:
      " If you are a yoga enthusiast, you might practice breathing during your yoga sessions. You may have heard the phrase 'practice breathe exercises' in the event that you had to see your therapist or your doctor. If you're under stress, you could have done it...",
    id: 2
  },
  {
    title: '10 Breathing Exercises that can help ease Anxiety',
    image:
      'https://t3.ftcdn.net/jpg/06/43/07/12/360_F_643071289_I60pgWvCavlK0pswqkibpeYudr0HY9Ft.jpg',

    duration: '5 min',
    professorPics: [
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSExIJT3xI3BmkKXtxbDD6z0SdKoh5LOAARdQ&s'
    ],
    description:
      " If you are a yoga enthusiast, you might practice breathing during your yoga sessions. You may have heard the phrase 'practice breathe exercises' in the event that you had to see your therapist or your doctor. If you're under stress, you could have done it...",
    id: 3
  },
  {
    title: '10 Breathing Exercises that can help ease Anxiety',
    image:
      'https://t3.ftcdn.net/jpg/06/43/07/12/360_F_643071289_I60pgWvCavlK0pswqkibpeYudr0HY9Ft.jpg',

    duration: '5 min',
    professorPics: [
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSExIJT3xI3BmkKXtxbDD6z0SdKoh5LOAARdQ&s'
    ],
    description:
      " If you are a yoga enthusiast, you might practice breathing during your yoga sessions. You may have heard the phrase 'practice breathe exercises' in the event that you had to see your therapist or your doctor. If you're under stress, you could have done it...",
    id: 4
  },
  {
    title: '10 Breathing Exercises that can help ease Anxiety',
    image:
      'https://t3.ftcdn.net/jpg/06/43/07/12/360_F_643071289_I60pgWvCavlK0pswqkibpeYudr0HY9Ft.jpg',

    duration: '5 min',
    professorPics: [
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSExIJT3xI3BmkKXtxbDD6z0SdKoh5LOAARdQ&s'
    ],
    description:
      " If you are a yoga enthusiast, you might practice breathing during your yoga sessions. You may have heard the phrase 'practice breathe exercises' in the event that you had to see your therapist or your doctor. If you're under stress, you could have done it...",
    id: 5
  },
  {
    title: '10 Breathing Exercises that can help ease Anxiety',
    image:
      'https://t3.ftcdn.net/jpg/06/43/07/12/360_F_643071289_I60pgWvCavlK0pswqkibpeYudr0HY9Ft.jpg',

    duration: '5 min',
    professorPics: [
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSExIJT3xI3BmkKXtxbDD6z0SdKoh5LOAARdQ&s'
    ],
    description:
      " If you are a yoga enthusiast, you might practice breathing during your yoga sessions. You may have heard the phrase 'practice breathe exercises' in the event that you had to see your therapist or your doctor. If you're under stress, you could have done it...",
    id: 6
  }
];

export const peopleList = [
  {
    id: 1,
    name: 'Mike',
    email: 'Mike@gmail.com',
    updateTime: Date.now() - 86400000,
    messages: [
      { text: 'Hii', status: 'sent', time: Date.now() - 86408000, seen: true },
      {
        text: 'Hii',
        status: 'received',
        time: Date.now() - 86407000,
        read: true
      },
      {
        text: 'How are you?',
        status: 'sent',
        time: Date.now() - 86406000,
        seen: true
      },
      {
        text: 'I am fine I am fine I am fine I am fine!',
        status: 'received',
        time: Date.now() - 86405000,
        read: true
      },
      { text: 'Hii', status: 'sent', time: Date.now() - 86408000, seen: true },
      {
        text: 'Hii',
        status: 'received',
        time: Date.now() - 86407000,
        read: true
      },
      {
        text: 'How are you?',
        status: 'sent',
        time: Date.now() - 86406000,
        seen: false
      },
      {
        text: 'I am fine I am fine I am fine I am fine!',
        status: 'received',
        time: Date.now() - 86405000,
        read: true
      },
      { text: 'Hii', status: 'sent', time: Date.now() - 86408000 },
      {
        text: 'Hii',
        status: 'received',
        time: Date.now() - 86407000,
        read: true
      },
      { text: 'How are you?', status: 'sent', time: Date.now() - 756000 },
      {
        text: 'I am fine I am fine I am fine I am fine! I am fine I am fine I am fine I am fine! I am fine I am fine I am fine I am fine!',
        status: 'received',
        time: Date.now() - 705000,
        read: true
      }
    ]
  },
  {
    id: 2,
    name: 'John',
    email: 'john@gmail.com',
    updateTime: Date.now() - 86600600,
    messages: [
      {
        text: 'Movie?',
        status: 'sent',
        time: Date.now() - 86608000,
        seen: true
      },
      {
        text: 'Which one ?',
        status: 'received',
        time: Date.now() - 86607000,
        read: true
      },
      {
        text: 'Iron Man',
        status: 'sent',
        time: Date.now() - 86606000,
        seen: false
      },
      {
        text: 'Lets go!',
        status: 'received',
        time: Date.now() - 86605000,
        read: true
      }
    ]
  },
  {
    id: 3,
    name: 'Rohan',
    email: 'rohan@gmail.com',
    updateTime: Date.now() - 83400000,
    messages: [
      { text: 'Hey', status: 'sent', time: Date.now() - 83408000 },
      {
        text: 'Hii',
        status: 'received',
        time: Date.now() - 83407000,
        read: true
      },
      {
        text: 'When will we meet?',
        status: 'sent',
        time: Date.now() - 83406000
      },
      {
        text: 'today evening',
        status: 'received',
        time: Date.now() - 83405000,
        read: false
      }
    ]
  },
  {
    id: 4,
    name: 'Rohan',
    email: 'rohan@gmail.com',
    updateTime: Date.now() - 83400000,
    messages: [
      { text: 'Hey', status: 'sent', time: Date.now() - 83408000 },
      {
        text: 'Hii',
        status: 'received',
        time: Date.now() - 83407000,
        read: true
      },
      {
        text: 'When will we meet?',
        status: 'sent',
        time: Date.now() - 83406000
      },
      {
        text: 'today evening',
        status: 'received',
        time: Date.now() - 83405000,
        read: false
      }
    ]
  },
  {
    id: 5,
    name: 'Rohan',
    email: 'rohan@gmail.com',
    updateTime: Date.now() - 83400000,
    messages: [
      { text: 'Hey', status: 'sent', time: Date.now() - 83408000 },
      {
        text: 'Hii',
        status: 'received',
        time: Date.now() - 83407000,
        read: true
      },
      {
        text: 'When will we meet?',
        status: 'sent',
        time: Date.now() - 83406000
      },
      {
        text: 'today evening',
        status: 'received',
        time: Date.now() - 83405000,
        read: false
      }
    ]
  },
  {
    id: 6,
    name: 'Rohan',
    email: 'rohan@gmail.com',
    updateTime: Date.now() - 83400000,
    messages: [
      { text: 'Hey', status: 'sent', time: Date.now() - 83408000 },
      {
        text: 'Hii',
        status: 'received',
        time: Date.now() - 83407000,
        read: true
      },
      {
        text: 'When will we meet?',
        status: 'sent',
        time: Date.now() - 83406000
      },
      {
        text: 'today evening',
        status: 'received',
        time: Date.now() - 83405000,
        read: false
      }
    ]
  },
  {
    id: 7,
    name: 'Rohan',
    email: 'rohan@gmail.com',
    updateTime: Date.now() - 83400000,
    messages: [
      { text: 'Hey', status: 'sent', time: Date.now() - 83408000 },
      {
        text: 'Hii',
        status: 'received',
        time: Date.now() - 83407000,
        read: true
      },
      {
        text: 'When will we meet?',
        status: 'sent',
        time: Date.now() - 83406000
      },
      {
        text: 'today evening',
        status: 'received',
        time: Date.now() - 83405000,
        read: false
      }
    ]
  },
  {
    id: 8,
    name: 'Rohan',
    email: 'rohan@gmail.com',
    updateTime: Date.now() - 83400000,
    messages: [
      { text: 'Hey', status: 'sent', time: Date.now() - 83408000 },
      {
        text: 'Hii',
        status: 'received',
        time: Date.now() - 83407000,
        read: true
      },
      {
        text: 'When will we meet?',
        status: 'sent',
        time: Date.now() - 83406000
      },
      {
        text: 'today evening',
        status: 'received',
        time: Date.now() - 83405000,
        read: false
      }
    ]
  },
  {
    id: 9,
    name: 'Rohan',
    email: 'rohan@gmail.com',
    updateTime: Date.now() - 83400000,
    messages: [
      { text: 'Hey', status: 'sent', time: Date.now() - 83408000 },
      {
        text: 'Hii',
        status: 'received',
        time: Date.now() - 83407000,
        read: true
      },
      {
        text: 'When will we meet?',
        status: 'sent',
        time: Date.now() - 83406000
      },
      {
        text: 'today evening',
        status: 'received',
        time: Date.now() - 83405000,
        read: false
      }
    ]
  },
  {
    id: 10,
    name: 'Rohan',
    email: 'rohan@gmail.com',
    updateTime: Date.now() - 83400000,
    messages: [
      { text: 'Hey', status: 'sent', time: Date.now() - 83408000 },
      {
        text: 'Hii',
        status: 'received',
        time: Date.now() - 83407000,
        read: true
      },
      {
        text: 'When will we meet?',
        status: 'sent',
        time: Date.now() - 83406000
      },
      {
        text: 'today evening',
        status: 'received',
        time: Date.now() - 83405000,
        read: false
      }
    ]
  }
];
